import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { AppState, ConfigService } from '@fcom/core';
import { casProfileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { CasCustomerType, CasProfile } from '@fcom/core-api/login';
import { recurseLangParam } from '@fcom/common';

const deny = (router: Router, childRoute: ActivatedRouteSnapshot): false => {
  const lang = recurseLangParam(childRoute);
  const url = `/${lang}/corporate/home`;
  router.navigateByUrl(url, { replaceUrl: true });
  return false;
};

export const corporateGuard: CanActivateFn = (_, state) => {
  const router = inject(Router);

  if (state.url.endsWith('corporate')) {
    router.navigate([state.url, 'home']);
  }

  return true;
};

export const corporateChildGuard: CanActivateChildFn = (childRoute) => {
  const platform = inject(PLATFORM_ID);
  const store$ = inject(Store<AppState>);
  const router = inject(Router);

  const [urlSegment] = childRoute.url?.slice(-1) || [];

  if (isPlatformServer(platform) || urlSegment?.path === 'home') {
    return true;
  }

  return store$.pipe(
    casProfileOrUndefinedIfNotLoggedIn(),
    map((profile: CasProfile) => {
      if (profile?.customerType === CasCustomerType.CORPORATE_USER) {
        return true;
      }
      return deny(router, childRoute);
    })
  );
};

export const featureFlagGuardData: CanActivateFn = (route) => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  if (!configService.cfg.enableCorporateData) {
    return deny(router, route);
  }
  return true;
};
